<template>
  <div v-if="value" class="is-flex">
    <div class="buttons is-hidden-mobile filter-buttons">
      <a
        v-for="(option, idx) in value"
        :key="idx"
        class="button"
        :class="{ 'is-primary is-outlined': option.selected }"
        @click="onButtonsChange(idx)"
        >{{ option.value }}</a
      >
    </div>
    <multiselect-field
      :value="value"
      class="is-hidden-tablet"
      :emptyLabel="$t('Choose filter values')"
      @input="onChange"
    />
  </div>
</template>

<script>
import { MultiselectField } from "@/components/form"

// "value" Example = [{ value: "Amazon", selected: false }, { value: "Google", selected: false }]
export default {
  name: "filter-buttons",
  props: ["value"],
  components: { MultiselectField },
  methods: {
    onButtonsChange(optionId) {
      const options = [...this.value]
      options[optionId].selected = !options[optionId].selected
      this.onChange(options)
    },
    onChange(options) {
      this.$emit("change", options)
      this.$emit("input", options)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-buttons {
  margin: 0 0 -0.5rem 0;
}
</style>
